import './text-input.scss'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import { useSessionQuery } from '../../api/api'

const SlugTextInput = ({
  label = 'Link',
  name = 'slug',
  type = 'text',
  value,
  onChange,
  onEnter,
}) => {
  const { data: user } = useSessionQuery()
  const inputValue = value === null ? '' : value
  function handleKeydown(evt) {
    if (evt.key === 'Enter' && onEnter !== undefined) {
      onEnter()
    }
  }
  return (
    <div className="text-input slug-input">
      <label htmlFor={name}>{label}</label>
      <div className="input-container">
        <div className="slug-label">{user.name}.sharefol.io/</div>
        <input
          type={type}
          value={inputValue}
          onChange={onChange}
          name={name}
          id={name}
          placeholder="my-portfoio"
          onKeyUp={handleKeydown}
        />
      </div>
    </div>
  )
}

export default SlugTextInput
